import axios from '_u/axios'

// 查询用户列表
export const customerList = (body) => {
    return axios.post('api/customer/info/list', body)
}

// 查询用户详情
export const customerView = (id) => {
    return axios.post('api/customer/info/view', { id })
}

// 新增用户
export const customerAdd = (body) => {
    return axios.post('api/customer/info/add', body)
}

// 修改用户
export const customerUpdate = (body) => {
    return axios.post('api/customer/info/update', body)
}

// 启用/禁用
export const customerEnabled = (id) => {
    return axios.post('api/customer/info/enabled', { id })
}

// 重置密码
export const resetPwd = (id) => {
    return axios.post('api/customer/info/resetPwd', { id })
}

// 查询岗位列表
export const roleList = (body) => {
    return axios.post('api/sys/org/list', body)
}

// 查询岗位详情
export const roleView = (id) => {
    return axios.post('api/sys/org/view', { id })
}

// 新增岗位
export const roleAdd = (body) => {
    return axios.post('api/sys/org/add', body)
}

// 修改岗位
export const roleUpdate = (body) => {
    return axios.post('api/sys/org/update', body)
}

// 删除岗位
export const roleDelete = (id) => {
    return axios.post('api/sys/org/delete', { id })
}